<!-- gallery -->
<template>
  <div class="wrapper">
    <div class="title">GALLERY</div>
    <div class="imgList">
      <div class="item" v-for="(item, index) in imgList" :key="index">
        <img :src="item" alt="">
      </div>
    </div>
    <div class="detail">Created by KW</div>
  </div>
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  }
}

</script>
<style lang='scss' rel='stylesheet/scss' scoped>
@import '../style/common.scss';
.imgList {
  display:flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 50%;
  .item{
    box-shadow: 0 1px 1px hsl(0deg 0% 0% / 8%), 0 2px 2px hsl(0deg 0% 0% / 8%), 0 4px 4px hsl(0deg 0% 0% / 8%), 0 8px 8px hsl(0deg 0% 0% / 8%), 0 16px 16px hsl(0deg 0% 0% / 8%);
    border-radius: 10px;
    width:19%;
    overflow: hidden;
    margin: 1%;
    transition: all .3s;
    &:hover{
    transform: scale(1.5);
    }
    img{
      width:100%;
      display: block;
    }
  }
}
.detail{
  font-size: 15px;
  color: gray;
  transform: translateY(30px);
}
</style>